import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import ButtonMui from '@mui/material/Button'

const styleByVariant = {
  primary: 'focus:bg-yellow-500 focus:text-blue-700 focus:outline-focus'
}

const disabledSx = {
  '&.Mui-disabled': {
    backgroundColor: '#C5CDDA!important',
    color: '#8A94A2!important',
    borderWidth: '2px!important'
  }
}

const typeButton = {
  primary: 'contained',
  secondary: 'outlined',
  alternative: 'bg-blue-gray-600 hover:bg-neutral-700 text-white',
  text: 'text'
}

const sizeMap = {
  xxs: 'max-w-24',
  xss: 'max-w-28',
  xs: 'max-w-32',
  s: 'max-w-40',
  m: 'max-w-56',
  l: 'max-w-72',
  xl: 'max-w-84',
  full: ''
}

export const Button = ({
  el: El = 'button',
  variant = 'primary',
  className,
  size = 'm',
  spaceSize = 'large',
  color = 'primary',
  fullWidth = true,
  classes = {},
  type = 'button',
  ...props
}) => {
  return (
    <ButtonMui
      component={El}
      variant={typeButton[variant]}
      color={color}
      fullWidth={fullWidth}
      size={spaceSize}
      sx={variant !== 'text' ? disabledSx : undefined}
      classes={{
        outlined: 'border-2 bg-white hover:border-2',
        outlinedPrimary: 'border-blue-700',
        outlinedSecondary: 'border-red-800 text-red-800 hover:border-red-800 hover:bg-white',
        outlinedSizeLarge: 'px-2',
        ...classes
      }}
      className={clsx(
        sizeMap[size],
        'hover:border-2',
        'font-lg rounded text-center',
        styleByVariant[variant],
        className
      )}
      type={type}
      {...props}
    />
  )
}

Button.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  color: PropTypes.string,
  el: PropTypes.elementType,
  fullWidth: PropTypes.bool,
  size: PropTypes.string,
  spaceSize: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string
}
